const selectors = {
  accordion: '[data-accordion]',
  accordionTrigger: '[data-accordion-trigger]',
  accordionContent: '[data-accordion-content]',
}

class ComponentAccordionGroup extends HTMLElement {
  #activeAccordion = 0;

  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }

  setupAccordions() {
    this.accordions?.forEach((accordion, index) => {
      const trigger = accordion.querySelector(selectors.accordionTrigger);
      const content = accordion.querySelector(selectors.accordionContent);

      if (!trigger || !content) return;
      
      accordion.setAttribute('data-index', index);
      trigger.setAttribute('aria-controls', `accordion-content-${index}`);
      trigger.setAttribute('data-index', index);
      content.setAttribute('id', `accordion-content-${index}`);

      trigger.addEventListener('click', this.handleClick);
    })
  }

  updateAccordions() {
    this.accordions?.forEach((accordion, index) => {
      const isExpanded = this.#activeAccordion === index;
      const trigger = accordion.querySelector(selectors.accordionTrigger);
      const content = accordion.querySelector(selectors.accordionContent);

      if (!trigger || !content) return;

      trigger.setAttribute('aria-expanded', isExpanded);
      accordion.setAttribute('data-state', isExpanded ? 'expanded' : 'collapsed');

      if (isExpanded) {
        content.removeAttribute('inert');
      } else {
        content.setAttribute('inert', '');
      }
    });
  }

  handleClick(event) {
    const index = parseInt(event.currentTarget.dataset.index);

    if (this.#activeAccordion === index) {
      this.#activeAccordion = null;
    } else {
      this.#activeAccordion = index;
    }

    this.updateAccordions();
  }

  connectedCallback() {
    this.accordions = this.querySelectorAll(selectors.accordion);

    this.setupAccordions();
    this.updateAccordions();
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', ComponentAccordionGroup);
}